import { resolvePath, usePath } from "@/contexts/path/path";
import { useMutation, useQuery } from "@apollo/client";
import {
  FOLLOW_SIMILAR_LISTINGS,
  UNFOLLOW_SIMILAR_LISTINGS,
} from "@/graphql/mutations/listing";
import { useAuthState } from "@/contexts/auth/auth.provider";
import React, { useEffect, useState } from "react";
import GET_RELATED_LISTINGS from "@/graphql/queries/related-listings";
import { ListingHolder } from "@/containers/UserListings/UserListings";
import css from "@/components/Listing/ListingScreen/.module.scss";
import { Checkbox, Modal } from "@aqar-app/react-ui";
import LoginAlert from "@/components/login-alert";
import { ClassicModal } from "@/components/Listing/ListingScreen/classicModal";
import logger from "@/console";
import { HorizontalListing } from "@/components/Listing/ListingCard";
import { trackClickSimilarListing } from "@/lib/tracking/trackNavigationEvents";
import Icon from "@/components/icon";
import AppLink from "@/components/new-resolver/app.ink";
import { CLOSED_STATUS_MAP } from "@/components/Listing/ListingScreen/alert";
import {
  listingToEECItemObject,
  trackSelectItem,
  trackViewItemList,
} from "@/lib/tracking/trackEECEvents";

const scrollToTop = () => {
  window.scrollTo(0, 0);
};

export function RelatedListings({ listing, onListingChange }) {
  const isOpen = !CLOSED_STATUS_MAP[listing.status];
  const {
    updateContext,
    categoriesDictionary,
    listingType,
    category,
    city,
    basePath: b,
    district,
    direction,
    filters,
  } = usePath();
  const [followSimilarListings] = useMutation(FOLLOW_SIMILAR_LISTINGS);
  const [unFollowSimilarListings] = useMutation(UNFOLLOW_SIMILAR_LISTINGS);
  const { token } = useAuthState();
  const [mySearches, setSearches] = useState({});
  useEffect(() => {
    try {
      setSearches(JSON.parse(localStorage.getItem("mySearches")) || {});
    } catch {
      setSearches({});
    }
  }, []);
  const {
    data: { Web: { related: { listings, path } = {} } = {} } = {},
    loading,
  } = useQuery(GET_RELATED_LISTINGS, {
    variables: {
      id: listing.id,
      size: 5,
    },
    onCompleted: (data) => {
      const relatedListings = data?.Web?.related?.listings;
      if (relatedListings?.length && typeof window !== "undefined") {
        trackViewItemList({
          itemListName: "related_listings",
          listingType: category?.ga_listing_type || listingType,
          category:
            category?.ga_property_category ||
            (category || categoriesDictionary["0"])?.en,
          cityName: city?.name_en,
          directionName: direction?.name_en,
          districtName: district?.name_en,
          count: relatedListings.length,
          listings: (relatedListings || []).map((listing, index) =>
            listingToEECItemObject(listing, index, categoriesDictionary),
          ),
        });
      }
    },
  });

  if (loading)
    return (
      <>
        <ListingHolder />
        <ListingHolder />
        <ListingHolder />
        <ListingHolder />
        <ListingHolder />
      </>
    );
  if (!listings?.length) return null;
  return (
    <div className={css.related}>
      <div className={css.header}>
        <h4>الإعلانات المشابهة</h4>
        <Checkbox
          defaultChecked={
            !!mySearches[`${listing.category}${listing.district_id}`]
          }
          onClick={(e) => {
            e.preventDefault();
            if (!token) {
              e.preventDefault();
              return Modal.open(
                <LoginAlert text="يرجى تسجيل الدخول لإتمام المتابعة" />,
              )(e);
            }
            e.target.disabled = true;
            if (e.target.checked) {
              followSimilarListings({
                context: { token },
                variables: { listingId: listing.id },
              })
                .then(({ data }) => {
                  if (data?.User?.followSimilarListings) {
                    localStorage.setItem(
                      "mySearches",
                      JSON.stringify({
                        ...mySearches,
                        [`${listing.category}${listing.district_id}`]:
                          Date.now() + 24 * 3600,
                      }),
                    );
                    e.target.checked = true;
                    return;
                  }

                  throw {};
                })
                .catch((error) => {
                  e.target.checked = false;

                  Modal.open(
                    <ClassicModal
                      ok={{
                        label: "حسنا",
                        cb: (e) => Modal.close(e) /*  router
                            .push("/user/searches")
                            .then(() =>),*/,
                      }}
                      body={
                        <p>
                          {error.message ||
                            "وصلت الحد ألأغلى للمتابعات هل تريد حذف البعض"}
                        </p>
                      }
                      title="الحد الاقصى للمتابعات"
                    />,
                  )(e);
                })
                .finally(() => (e.target.disabled = false));
            } else {
              unFollowSimilarListings({
                context: { token },
                variables: { listingId: listing.id },
              })
                .catch(logger.log)
                .finally(() => {
                  e.target.disabled = false;
                  e.target.checked = false;
                  localStorage.setItem("mySearches", {
                    ...mySearches,
                    [`${listing.category}${listing.district_id}`]: null,
                  });
                });
            }
          }}
          switch
        >
          <p>متابعة</p>
        </Checkbox>
      </div>
      <div className={css.list}>
        {listings?.map((l, index) => (
          <HorizontalListing
            onClick={() => {
              if (onListingChange) return onListingChange(l);
              updateContext({ listing: l });
              trackClickSimilarListing({
                ...l,
                category: categoriesDictionary?.[l.category],
              });
              trackSelectItem({
                itemListName: `related_listings_${listing.id}`,
                listingType: category?.ga_listing_type,
                category: category?.en,
                cityName: city?.name_en,
                directionName: direction?.name_en,
                districtName: district?.name_en,
                filters,
                count: listings.length,
                listings: listings.map((lstng, index) =>
                  listingToEECItemObject(lstng, index, categoriesDictionary),
                ),
              });
            }}
            preloadImage={!isOpen}
            key={l.id}
            index={index}
            listing={l}
          />
        ))}
      </div>
      {b?.includes("map") ? null : (
        <AppLink
          path={path}
          className={css.more}
          onClick={() => {
            resolvePath(path).then((data) => {
              updateContext({
                listing: null,
                category: null,
                city: null,
                district: null,
                direction: null,
                ...data,
              });
              scrollToTop();
            });
          }}
        >
          تحميل المزيد
          <Icon asSVG width={20} height={20} name="LoadMore-white" />
        </AppLink>
      )}
    </div>
  );
}
